import * as Yup from "yup";

export const OcrValidationFieldsValidation = () => Yup.object().shape({
  name: Yup.string().required(),
  label: Yup.string().required(),
  width: Yup.number().positive().required(),
  order: Yup.number().positive().required(),
  row: Yup.number().positive().required()
});